pageId = 'page-todolist'
page = "##{ pageId }"

$ ->
  $(document).on 'click', "#{ page } .detail-action-edit", (e) ->
    e.preventDefault()
    $title = $('.todolist .title')
    $title.find('.progress').remove()
    if $title.is(':visible')  #避免重复点击
      $title.hide()
      $('.todolist-actions .edit').trigger 'click'
    else
      $('input.todolist-name').focus()

  .on 'click', "#{ page } .detail-action-del", (e) ->
    e.preventDefault()
    $('.todolist-actions .del').trigger 'click'

  .on 'ajax:success', "#{ page } .detail-action-archive", (e, result) ->
    if result.success
      tower.stack.load location.href,
        nocache: true
        replace: true

  .on 'mousedown touchstart', "#{ page } .link-more-completed", (e) ->
    $link = $(@)
    $link.data 'params', "till=#{ $('.todo.completed:last').data('closed-at') }"

  .on 'ajax:success', "#{ page } .link-more-completed", (e, result) ->
    return  unless result.success

    $link = $(@)
    $html = $(result.html)

    if !$html.length
      $link.data('loading')?.destroy()
      $link.remove()
      return

    tower.adjustReadableTime $html
    $html.appendTo $link.prev('.todos-completed')


$(document).on 'pjaxload#' + pageId, (e, $page, page) ->
  tower.adjustTodo()
  tower.adjustProjInfo()
  tower.adjustAuthor()
  tower.adjustAttachment()
  tower.adjustCommentEvents()
  tower.adjustCommentsLike()
  tower.foldComments()

  renderProgress()

  if $page.is('[data-archived], [data-deleted]')
    $('.todolist-stick-checkbox').attr 'disabled', 'disabled'

  completedTpl = $('#tpl-todos-completed')
  if completedTpl.length
    completedTodosEl = $(completedTpl.html())
    todoCount = completedTodosEl.data('length')

    $('.todolist .todos-completed').replaceWith completedTodosEl
    if completedTodosEl.find('.todo').length < todoCount
      $('<a/>',
        href: completedTodosEl.data('url')
        'class': 'link-more-completed'
        text: '更多已完成任务...'
        'data-remote': 'true'
        'data-method': 'get'
        'data-loading': 'true').insertAfter completedTodosEl

    completedTpl.remove()

  # 加载更多未完成任务
  $link = $('#link-load-more-todos')
  $('#link-load-more-todos').on 'mouseenter', ->
    $link.attr 'href', "#{$link.data('url')}?offset=#{$('.todos-uncompleted .todo').length}"
  .on 'ajax:success', (e, result) ->
    return unless result.success
    $todos = $(result.html)
    if $todos.length
      tower.adjustTodo($todos)
      tower.initPermission($todos)
      $todos.appendTo $('.todos-uncompleted')
    else
      $link.data('loading')?.destroy()
      $link.remove()

  $page.on 'todoremove todocreate todoupdate todocomplete todoreopen', (e) ->
    if e.type is 'todoreopen' and $page.find('.todolist-archive-tip').length
      tower.stack.load location.href,
        nocache: true
        replace: true

    completed = $page.find('.todos-completed').data('length') * 1
    completed = if completed > 10 then completed - 10 else 0
    completed += $page.find('.todos-completed .todo').length
    total = $page.find('.todos-uncompleted .todo').length + completed
    renderProgress(completed, total)

renderProgress = (completed, total) ->
  $title = $('.todolist .title')

  if typeof total isnt 'undefined'
    count = parseInt(completed / total * 100)
    $title.find('.progress-pie')
      .attr 'title', count + '%'
      .attr 'data-pie', count
    $title.find('.progress-text').text (total - completed) + '/' + total
  else
    $title.find('.progress-wrap').remove()
    $title.find('h4 .name').after $('#tpl-todolist-progress').html()
